import { authentication } from "@microsoft/teams-js"
import { BotResponse, Citation, UserInfo } from "../../api/models"
import jwtDecode from 'jwt-decode';

export const messageRole: any = (message: string) => {
  switch (message) {
    case 'Top 10 projects for review':
      return 'system'
    case 'Show me learnings related to Project Management':
      return 'system'
    case 'Show me learnings related to Engineering':
      return 'system'
    case 'Show me leanings related to Sales and Tendering':
      return 'system'
    default:
      return 'user'
  }
}

export const getDropdownLabel = (selections: string[], schema: string[], level: number, schemaLevel: number): string => {
  let result = ''

  if (selections.length > 0) result = `You selected ${selections[level]} as a ${schema[schemaLevel - 1]}. `

  result += `Please select a ${schema[level]}:`

  return result
}

export const modalProps = {
  titleAriaId: 'labelId',
  subtitleAriaId: 'subTextId',
  isBlocking: true,
  styles: { main: { maxWidth: 450 } },
}

export const parseCitationFromMessage = (message: BotResponse) => {
  if (message?.role && message?.role === "tool") {
    try {

      const toolMessage = JSON.parse(message.content);
      return toolMessage;
    }
    catch {
      return [];
    }
  }
  return [];
}

export const onViewSource = (citation: Citation) => {
  if (citation.url && !citation.url.includes("blob.core"))
    window.open(citation.url, "_blank");
};

export const getCurrentTimestamp = (): string => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

export const parseCitations = (input: Citation[] | undefined): string => {

  let citations: Citation[] = [];

  if (input != undefined) {

    input.forEach(element => {
      let cit: Citation = {
        title: element.title == undefined ? "" : element.title,
        filepath: element.url,
        content: element.content,
        id: element.id,
        url: element.url,
        metadata: element.metadata,
        chunk_id: element.chunk_id,
        reindex_id: element.reindex_id,
        reference: element.reference,
        page_from: element.page_from,
        page_to: element.page_to,
        documentNumber: element.documentNumber,
        fileExtension: element.fileExtension,
        languageCode: element.languageCode,
        partId: element.partId,
        revision: element.revision,
        section: element.section,
        part_index: element.part_index
      }
      citations.push(cit);
    });
  }

  return JSON.stringify(citations);;
};

export const isJson = (str: string) => {
 
try {
    const parsed = JSON.parse(str);
    return typeof parsed === 'object' && parsed !== null;
  } catch {
    return false;
  }

}

export const decodeToken = (token: string): any => {
  try {
    const decoded = jwtDecode(token);
    console.log("Decoded token:", decoded);
    return decoded;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

export const getTeamsAuthToken = async (): Promise<string> => {
  return await authentication.getAuthToken({
    resources: ["https://graph.microsoft.com"],
    silent: true
  });
};

export const createUserInfoList = (token: string, claims: any): UserInfo[] => {
  return [{
    access_token: token,
    expires_on: claims.exp.toString(),
    id_token: token,
    provider_name: "Microsoft",
    user_claims: Object.entries(claims).map(([type, value]) => ({ type, value })),
    user_id: claims.oid
  }];
};

export const setEmailInLocalStorage = (email: string) => {
  if (email) {
    localStorage.setItem('email', email);
    sessionStorage.setItem('email', email);
  }
};

export const setUserIdInLocalStorage = (userId: string) => {
  if (userId) {
    localStorage.setItem('userId', userId);
    sessionStorage.setItem('userId', userId);
  }
};

export const setAccessTokenInLocalStorage = (accessToken: string) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    sessionStorage.setItem('accessToken', accessToken);
  }
};

export const handleChatHistoryDeleted = async (
  isTeams: boolean,
  messages: BotResponse[],
  setAvailableOptions: (options: any) => void,
  handleCreateConversation: (agent: string) => Promise<boolean>,
  newChat: () => void
): Promise<void> => {
  let isNewChat = false;
  try {
    const agent = isTeams 
      ? localStorage.getItem("dataSource") 
      : sessionStorage.getItem("dataSource");

    messages.length = 0;
    setAvailableOptions(undefined);
    
    if (agent === 'unstructured' || agent === null) {
      isNewChat = true;
    } else {
      localStorage.removeItem("dataSource");
      localStorage.removeItem("title");
      localStorage.removeItem("historylistConId");
      localStorage.removeItem("conversationId");
      
      const success = await handleCreateConversation(agent);
      if (!success) {
        isNewChat = true;
      }
    }
  } catch (error) {
    console.error('Error handling chat deletion:', error);
    isNewChat = true;
  } finally {
    if (isNewChat) {
      newChat();
    }
  }
};